import './App.css';
import Home from './screens/Home/Home';
import Products from './screens/Products/Products';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import ProductDetail from './screens/ProductDetail/ProductDetail';
import QuotationForm from './screens/QuotationForm/QuotationForm';
import Faq from './screens/Faq/Faq';
import ScrollToTop from './utils/scrollToTop';
import AboutUs from './screens/AboutUs/AboutUs';

function App() {
  return (
    <div id="outer-container">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/quotation" element={<QuotationForm />} />
          <Route path="/faq" element={<Faq />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
